export default "__VITE_ASSET__MkxybQY1__"